import { Navigate } from 'react-router-dom'
import { useClientContextStore } from '@/store/clientContext'
import { assetCatalogPath } from '@/components/assetCatalog/assetCatalogNav'

/**
 * Old `/asset-configuration/*` bookmarks → client workspace when a client
 * is already in context, otherwise Organization → Clients.
 */
export default function LegacyAssetCatalogRedirect({
  segment = 'overview',
}: {
  segment?: string
}) {
  const activeClient = useClientContextStore((s) => s.activeClient)

  if (activeClient?.id) {
    return <Navigate to={assetCatalogPath(activeClient.id, segment)} replace />
  }

  return <Navigate to="/organization/clients" replace />
}
